import React, { useState, useEffect } from "react"
import { Link } from "gatsby"
import {motion, useViewportScroll, AnimatePresence, useCycle} from 'framer-motion'
import { GatsbyImage } from "gatsby-plugin-image"
import { RiCloseFill } from "react-icons/ri";

import "./header.scss"
import AnnouncementBar from "./announcement-bar"


const animHeader = {
  initial: {
    backgroundColor: "transparent"
  },
  visible: { 
    // opacity: 1, 
    // y: 0,
    backgroundColor: "transparent", 
    color: "white",
    transition: {
      duration: 0.5,
      staggerChildren: 0.15,
      staggerDirection: 1,
      delay: 0.3,
      ease: [0.38, 0.005, 0.215, 1],
      when: "beforeChildren",
    },
  },
  hidden: { 
    // opacity: 0, 
    // y: -30,
    backgroundColor: "#046484", 
    color: "white",
    transition: {
      duration: 0.5,
      staggerChildren: 0.15,
      staggerDirection: 1,
      // delay: 0.3,
      ease: [0.38, 0.005, 0.215, 1],
      when: "beforeChildren",
    },
  }
};

const headerAnim = {
  animate: {
    transition: {
      when: "beforeChildren",
      delayChildren: 0.4,
      staggerChildren: 0.05,
    },
  },
}

const announcement = {
  initial: { y: -20, opacity: 0 },
  animate: {
    y: 0,
    opacity: 1,
    transition: {
      ease: [0.38, 0.005, 0.215, 1],
      duration: 0.6,
    },
  },
}
const links = {
  initial: { y: 20, opacity: 0 },
  animate: {
    y: 0,
    opacity: 1,
    transition: {
      ease: [0.38, 0.005, 0.215, 1],
      duration: 0.6,
    },
  },
}


const Header = ({ header, site }) => {
  const data = { header, site }
  console.log("header", data)



  const [scrolled, setScrolled] = useCycle(false)

  useEffect(() => {
    window.addEventListener("scroll", () => {
      if (window.scrollY >= 100) {
        setScrolled(true)
      } else {
        setScrolled(false)
      }
    })
  }, [])



  const [open, cycleOpen] = useCycle(false, true);


   //scroll anim
   const [hidden, setHidden] = useState(false);

   const { scrollY } = useViewportScroll();
 
   function update() {
     if ( scrollY.current < scrollY.prev) {
       setHidden(false)
       console.log("visible")
     }
     if (scrollY?.current > 100 ) {
       setHidden(true)
       console.log("hidden")
     }
   }

   console.log("header", header)
 
   useEffect(() => {
     // return scrollY.onChange(() => console.log(scrollY));
     return scrollY.onChange(()=> update())
   });

  return (
    <>
      <motion.header
        className={scrolled ? "header active" : "header"}
        animate={hidden ? "hidden" : "visible"}
        variants={animHeader}
        initial="initial"
      >
        <motion.div
          variants={announcement}
          initial="initial"
          animate="animate"
          className="header__announcement"
        >
          <AnnouncementBar />
        </motion.div>
        <motion.div
          variants={headerAnim}
          initial="initial"
          animate="animate"
          className="header__main h-[80px] flex items-center "
        >
          <div className="container">
            <div className="flex justify-between w-full">
              {/* <Link to="/">{site.siteTitle}</Link> */}

              {header.logo && (
                <motion.div className="flex items-center">
                  <Link to="/">
                    <GatsbyImage
                      className="w-[200px]"
                      objectFit="contain"
                      loading="eager"
                      image={header.logo.asset.gatsbyImageData}
                      alt={header.logo.asset.altText}
                    />
                  </Link>
                </motion.div>
              )}

         
              <div className="hidden lg:flex gap-8 items-center">
                {header.menuDesktopPrimary.link.map((link, index) => {
                  const internalLink = link._type === "linkInternal"
                  const externalLink = link._type === "linkExternal"

                  console.log("internalLink", internalLink)

                  if (internalLink) {
                    const slug = link.page.slug.current

                    if (slug === "/home") {
                      return (
                        <motion.div>
                          <Link to="/" className="underline-anim" activeClassName="is-current">{link.title}</Link>
                        </motion.div>
                      )
                    } else {
                      return (
                        <motion.div>
                          <Link to={slug} className="underline-anim" activeClassName="is-current">{link.title}</Link> 
                        </motion.div>
                      )
                    }
                  } else {
                    return (
                      <motion.div>
                        <Link to={link.url} className="underline-anim" activeClassName="is-current">{link.title}</Link>
                      </motion.div>
                    )
                  }
                })}
              </div>

              <button className="hamburger-menu" onClick={cycleOpen}>
                <span></span>
                <span></span>
              </button>
            </div>
          </div>
        </motion.div>
      </motion.header>

      <AnimatePresence>
        {open && (
          <motion.aside
            // initial={{ width: 0, visibility: "visible" }}
            // animate={{
            //   width: "50vw",
            // }}
            // exit={{
            //   width: 0,
            //   transition: { delay: 0.7, duration: 0.3 }
            // }}
            initial="initial"
            animate="open"
            exit="closed"
            variants={overlayContainer}
            className="overlay-menu text-black"
          >
            <div
              // initial="closed"
              // animate="open"
              // exit="closed"
              // variants={overlayContainer}
              className="p-8 h-full"
            >
              <button className="close-menu" onClick={cycleOpen}>
                <RiCloseFill className="h-[50px] w-[50px]" fill="#FFF"/>
              </button>
              <nav className="flex flex-col items-center justify-center gap-8 text-3xl lg:text-6xl font-bold uppercase w-full h-full">
                <div className="bg-white/50 relative overflow-hidden">
                  <motion.div variants={overlayItemVariants}>
                    <Link to="/">Home</Link>
                  </motion.div>
                </div>
                
                {header.menuDesktopPrimary.link.map((link, index) => {
                  const internalLink = link._type === "linkInternal"
                  const externalLink = link._type === "linkExternal"

                  if (internalLink) {
                    const slug = link.page.slug.current

                    if (slug === "/home") {
                      return (
                        <div className="bg-white/50 relative overflow-hidden">
                          <motion.div variants={overlayItemVariants}>
                            <Link to="/">{link.title}</Link>
                          </motion.div>
                        </div>
                      )
                    } else {
                      return (
                        <div className="bg-white/50 relative overflow-hidden">
                          <motion.div variants={overlayItemVariants}>
                            <Link to={slug}>{link.title}</Link>
                          </motion.div>
                        </div>
                      )
                    }
                  } else {
                    return (
                      <div className="bg-white/50 relative overflow-hidden">
                        <motion.div variants={overlayItemVariants}>
                          <Link to={link.url}>{link.title}</Link>
                        </motion.div>
                      </div>
                    )
                  }
                })}
              </nav>
            </div>
          </motion.aside>
        )}
      </AnimatePresence>

      <svg
        className="overlay fixed z-50 "
        width="100%"
        height="100%"
        viewBox="0 0 100 100"
        preserveAspectRatio="none"
      >
        <path
          className="overlay__path"
          vector-effect="non-scaling-stroke"
          d="M 0 100 V 100 Q 50 100 100 100 V 100 z"
        />
      </svg>
    </>
  )
}

export default Header

const overlayContainer = {
  initial: {
    // top: "100%", visibility: "visible" 
    opacity: 0,
    // width: 0,
    visibility: "visible" 
  },
  open: {
    // top: "0",
    // width: 400,
    opacity: 1,
    transition: {
      staggerChildren: 0.05,
      staggerDirection: 1,
      ease: [0.38, 0.005, 0.215, 1],
      duration: .6
    }
  },
  closed: {
    // bottom: "100%",
    // width: 0,
    opacity: 0,
    transition: {
      staggerChildren: 0.05,
      staggerDirection: -1,
      delay: .3, 
      duration: 0.3,
      ease: [0.38, 0.005, 0.215, 1],
    }
  },
};

const overlayItemVariants = {
  initial: {
    // opacity: 0,
    y: 100,
  },
  closed: {
    // opacity: 0,
    y: -100,
    transition: {
      ease: [0.38, 0.005, 0.215, 1],
      duration: 0.6
    }
  },
  open: { 
    // opacity: 1,
    y: 0,
    transition: {
      ease: [0.38, 0.005, 0.215, 1],
      duration: 0.6
    }
  }
};